export enum IkasStorefrontThemeStatus {
  WAITING = "WAITING",
  READY = "READY",
}

export type IkasStorefrontTheme = {
  id: string;
  isMainTheme: boolean;
  name: string;
  status: IkasStorefrontThemeStatus;
  themeId: string;
  themeVersionId: string;
};
